import React from "react";
import StepperVer from "../../components/Verification/StepperVer";
import "./verification.css"; // Import the provided CSS styles

function Verification() {
  return (
    <div>
      <StepperVer />
    </div>
  );
}

export default Verification;
